import { render } from "./VehicleImageGallery.vue?vue&type=template&id=bea771fe"
import script from "./VehicleImageGallery.vue?vue&type=script&lang=js"
export * from "./VehicleImageGallery.vue?vue&type=script&lang=js"

import "./VehicleImageGallery.vue?vue&type=style&index=0&id=bea771fe&lang=css"
script.render = render

export default script